import { UserRound } from "lucide-react";
import Modal from "../../../../components/portal/Modal";
import UserInfo from "./UserInfo";
import CompanyInfo from "./ComanyInfo";
import AccountInfo from "./AccountInfo";
import BalanceInfo from "./BalanceInfo";
import UserRoles from "./UserRoles";

export default function UserDialogManager({ closeDialog, userData }) {
  return (
    <Modal
      onClose={closeDialog}
      closeIcon={true}
      modalWidth="max-w-4xl w-11/12 max-sm:w-95% max-md:px-4 max-md:py-4"
    >
      <div className="border-b-2 border-dBlue py-3 px-4 relative">
        <div className="flex items-center gap-3">
          <UserRound
            color="#0F6FDF"
            size={35}
            className="bg-blue-10 p-2 rounded-md"
          />
          <div>
            <h2 className="text-lg font-medium">
              {userData.fullName} ({userData.id})
            </h2>
            <p className="text-gray-500 text-sm">User Details</p>
          </div>
        </div>
      </div>
      <div className={`overflow-auto max-2xl:h-[80vh]`}>
        <div className="flex px-4 py-3 text-light-black gap-4 mt-2">
          <div className="w-full">
            <UserInfo userData={userData} />
            {/* User Roles */}
            <UserRoles userId={userData.id} />
            {/* User roles */}
          </div>
          <div className="w-full">
            <BalanceInfo userData={userData} />
            <CompanyInfo userData={userData} />
            <AccountInfo userData={userData} />
          </div>
        </div>
      </div>
    </Modal>
  );
}
